import { render, staticRenderFns } from "./TableCheckboxInput.vue?vue&type=template&id=1bc44b84&"
import script from "./TableCheckboxInput.vue?vue&type=script&lang=ts&"
export * from "./TableCheckboxInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports